import { Tab } from "@headlessui/react";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const TabItem = ({ item }) => (
  <Tab
    className={({ selected }) =>
      classNames(
        "group card overflow-hidden flex flex-col cursor-pointer !p-0",
        selected ? "border-purple-700 bg-purple-50" : "hover:bg-purple-50",
      )
    }
  >
    {/* Top image */}
    <div className="w-full h-48 overflow-hidden">
      <img
        src={item.image}
        alt={item.label[0]}
        className="w-full h-full object-cover"
      />
    </div>

    {/* Card body */}
    <div className="p-4 flex flex-col gap-2 items-center text-center">
      {/* Icon + Heading row */}
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-purple-100">
          <item.icon className="h-6 w-6 text-purple-700" aria-hidden="true" />
        </div>
        <h6 className="font-bold text-base text-purple-700">
          {item.label[0]}
          <sup>{item.label[1]}</sup>
        </h6>
      </div>

      {/* Description */}
      <p className="text-sm text-gray-600">{item.description}</p>
    </div>
  </Tab>
);

export default TabItem;
